import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { Observable } from "rxjs";
import { FeedbackDto } from "../model";

@Injectable({
  providedIn: "root",
})
export class FeedbackApiService {
  constructor(
    private viewerConfigurationService: ViewerConfigurationService,
    private http: HttpClient,
  ) {}

  public get headers(): any {
    return {
      headers: {
        Authorization: "Bearer " + this.authToken,
        Accept: "application/json",
      },
    };
  }

  public get adminUrl(): string {
    return this.viewerConfigurationService.getViewerConfiguration().viewerUrl;
  }

  public get authToken(): string {
    return this.viewerConfigurationService.getViewerConfiguration().token;
  }

  public get authType(): string {
    return this.viewerConfigurationService.getViewerConfiguration().authType;
  }

  public get queryParam(): string {
    return this.authType;
  }

  public get queryAuth(): string {
    return this.queryParam + "=" + this.authToken;
  }

  saveFeedbackImage(quadKey: string, query: string, rank: number, feedback: number): Observable<HttpEvent<String>> {
    const finalUrl = `${this.adminUrl}/api/compound/feedback/save`;
    const body: FeedbackDto = {
      embeddingsId: quadKey, // TODO change to real embeddingsId
      quadkey: quadKey,
      query,
      rank,
      feedback,
    };
    return this.http.post<String>(finalUrl, body, this.headers);
  }

  deleteFeedbackImage(quadKey: string, query: string, rank: number): Observable<HttpEvent<String>> {
    const finalUrl = `${this.adminUrl}/api/compound/feedback/delete`;
    const body: FeedbackDto = {
      embeddingsId: quadKey, // TODO change to real embeddingsId
      quadkey: quadKey,
      query,
      rank,
    };
    const options = {
      ...this.headers,
      body: body,
    };
    return this.http.delete<String>(finalUrl, options);
  }
}
